import React from "react";
import * as theme from "../theme";
import { Button } from "react-bootstrap";

export default function ActionButton(props) {
  const textSize = props.fontSize ? props.fontSize : "min(0.8vw, 15px)";

  return (
    <Button
      style={{
        display: "flex",
        width: "100%",
        height: "100%",
        maxHeight: "6vmin",
        backgroundColor: theme.COLORS.secondary_skyblue,
        borderRadius: 5,
        color: "white",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "GibsonRegular",
        fontSize: textSize,
        letterSpacing: 1,
        border: 0,
        ...props.style
      }}
      onClick={props.onClick}
      disabled={props.disabled}
      id={props.id}
    >
      {props.text}
    </Button>
  );
}
